export default "/images/df318f22ed0c9791327d814902d65537.avif";